var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteFieldIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6195",
    "data-name": "Group 6195",
    transform: "translate(-13208 -12747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG",
    transform: "translate(13208 12747)",
    fill: "#f5f5f5",
    stroke: "#dddfe1",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_78",
    "data-name": "Union 78",
    d: "M4.089,16.777a2.707,2.707,0,0,1-1.855-.724A2.4,2.4,0,0,1,1.467,14.3V3.537H.807a.816.816,0,0,1-.7-.38.722.722,0,0,1,0-.761.817.817,0,0,1,.7-.38H4.34L5.181.422a.774.774,0,0,1,.3-.308A.849.849,0,0,1,5.9,0H9.757a.85.85,0,0,1,.425.114.774.774,0,0,1,.3.308l.841,1.593h3.533a.817.817,0,0,1,.7.38.722.722,0,0,1,0,.761.816.816,0,0,1-.7.38h-.66V14.3a2.4,2.4,0,0,1-.768,1.748,2.708,2.708,0,0,1-1.855.724ZM3.081,14.3a.924.924,0,0,0,.295.672,1.041,1.041,0,0,0,.714.278H11.57a1.04,1.04,0,0,0,.714-.278.924.924,0,0,0,.295-.672V3.537h-9.5ZM6.141,2.016H9.519l-.263-.494H6.4ZM10.406,14.57a.833.833,0,0,1-.571-.223.735.735,0,0,1-.235-.539V5a.752.752,0,0,1,.4-.658.847.847,0,0,1,.807,0,.752.752,0,0,1,.4.658V13.81a.738.738,0,0,1-.236.538A.836.836,0,0,1,10.406,14.57Zm-2.576,0a.831.831,0,0,1-.571-.223.738.738,0,0,1-.236-.539V5a.752.752,0,0,1,.4-.658.847.847,0,0,1,.807,0,.752.752,0,0,1,.4.658V13.81a.739.739,0,0,1-.237.538A.834.834,0,0,1,7.83,14.57Zm-2.576,0a.834.834,0,0,1-.572-.223.74.74,0,0,1-.236-.539V5a.752.752,0,0,1,.4-.658.847.847,0,0,1,.807,0A.752.752,0,0,1,6.06,5V13.81a.738.738,0,0,1-.236.538A.834.834,0,0,1,5.254,14.57Z",
    transform: "translate(13223 12761)",
    fill: "#aeaeae"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFieldIcon);
export default __webpack_public_path__ + "static/media/delete-field-icon.42ffe150af2503cdbd21555a3d407d26.svg";
export { ForwardRef as ReactComponent };